import axios from 'axios'
import config from '@/config/config'

export const zapierSignUpHook = async (email, source = '') => {
  const formHookUrl = config.USER_SIGNUP_WEBHOOK

  const axiosConfig = {
    transformRequest: [(data, headers) => {
      delete headers.common['Content-Type']
      return data
    }]
  }

  const instance = axios.create(axiosConfig)

  const payload = {
    email,
    source
  }

  try {
    await instance.post(formHookUrl, JSON.stringify(payload))
  } catch (e) {
    console.log('Zappier error', e)
    throw new Error(e)
  }
}
